export default __webpack_public_path__ + "static/media/sgu-logo-white-300x139.96363571.png";